import Lesson from '@/models/Lesson';
import Unit from '@/models/Unit';

export const adapterLessonBlockOrder = (
  parents: Unit[],
  children: Record<string, Lesson[]>,
) => {
  const order = parents.map(unit => ({
    id: unit.id,
    lessonsIds: (children[String(unit.id)] ?? []).map(l => ({
      id: l.id,
    })),
  }));
  return order;
};
